import type { AnalysesTab, AnalysisPageMode } from '../types/analyses.types';

export const ANALYSIS_TITLES: Record<AnalysesTab, Record<AnalysisPageMode, string>> = {
	soil: {
		add: 'Nova Análise de Solo',
		edit: 'Editar Análise de Solo',
		view: 'Análise de Solo',
	},
	plant: {
		add: 'Nova Análise Foliar',
		edit: 'Editar Análise Foliar',
		view: 'Análise Foliar',
	},
};

export const ANALYSIS_SUBTITLES: Record<AnalysisPageMode, Record<AnalysesTab, string>> = {
	add: {
		soil: 'Preencha os dados da análise de solo',
		plant: 'Preencha os dados da análise foliar',
	},
	edit: {
		soil: 'Edite os dados da análise de solo',
		plant: 'Edite os dados da análise foliar',
	},
	view: {
		soil: 'Visualize os dados da análise de solo',
		plant: 'Visualize os dados da análise foliar',
	},
};

export const ANALYSIS_SECTION_TITLES: Record<AnalysesTab, string> = {
	soil: 'Dados da Análise de Solo',
	plant: 'Dados da Análise Foliar',
};
